import { css as e } from "@microsoft/fast-element";
import { normalize as m } from "../../common/normalize.js";
import { display as i } from "@matrix42/fast-foundation";
import { menuItemStyles as r } from "../../styles/menu-item.styles.js";
import { designTokens as t } from "../../design-tokens.js";
const $ = (o) => e`
  ${m}
  ${i("flex")}
  ${r(":host")}
  ::slotted(${o.prefix}-icon) {
    /* Layout */
    width: ${t.iconSize.sm} !important;
    height: ${t.iconSize.sm} !important;
    /* Style */
    color: inherit;
  }
`;
export {
  $ as menuItemStyles
};
